// extracted by mini-css-extract-plugin
export var content = "_ou-1";
export var fullScreen = "_ou-0";